import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import restaurants from "./restaurants";
import settings from "./settings";
import voip from "./voip";

Vue.use(Vuex);

const state = {
  sidebarShow: "responsive",
  sidebarMinimize: false,
  asideShow: false,
  darkMode: false,
  deviceSoftware: true,

  menuGroupsAsideShow: false,
  optionGroupsAsideShow: false, // in Menu Scraper
  optionGroupsAssignmentAsideShow: false, // in Menu V2 Items
  restaurantsAsideShow: false,
  menuSjabloonMakeLinkAsideShow: false,
  labelActivityLogsAsideShow: false,
  taskActivityLogsAsideShow: false,
  orderActivityLogsAsideShow: false,
  latestRestaurantActivitiesAsideShow: false,
  editTaskAsideShow: false,
  invoicePaymentsAsideShow: false,
  courierInvoicePaymentsAsideShow: false,
  courierInvoiceAdjustmentsAsideShow: false,
  courierWeeklyWorkTimesAsideShow: false,
  courierInternalNotesAsideShow: false,
  newImageAsideShow: false,
  selectNewImageAsideShow: false,
  assignImageToCategoryAsideShow: false,
  assignHeroImageToRestaurantAsideShow: false,
  changeHeroImageAsideShow: false,
  changeLogoAsideShow: false,
  sendRestaurantDetailsAsideShow: false,
  holidayItemAsideShow: false,

  menuV2: {
    variantManagementModalShow: false,
    variantOptionPriceModalShow: false,
  },

  // Filters
  filterShow: true,
  filters: {
    selectedRestaurant: null,

    users: {
      selectedLanguages: [],
      selectedType: null,
    },
    restaurants: {
      linkedMenus: {
        selectedCategories: [],
        selectedCategory: null,
        showDeleted: false,
      },
      selectedRestaurantsFilter: ["active", "inactive"],
      selectedRestaurantsANDFilter: [],
      selectedOriginator: undefined,
      selectedProvinces: [],
      selectedRegions: [],
      selectedLocations: [],
      selectedRepresentative: null,
      selectedDeviceType: undefined,
      selectedDeviceStatus: undefined,
      hasFcmDevice: null,
      selectedHubs: [],
      search: null,
      hasDistanceThreshold: null,
      dns: {
        showWithoutSubsite: false,
        showInactive: false,
        statusFilter: null,
        aRecordStatusFilter: null,
        aaaaRecordStatusFilter: null,
        aRecordIpFilter: null,
        aaaaRecordIpFilter: null,
      }
    },
    orders: {
      search: null,
      addressSearch: null,
      postalCodeSearch: null,
      selectedOrderStatus: "today",
      selectedOrderFeatureStatus: null,
      orderFeatureStatusCondition: "AND",
      selectedOrderChannel: null,
      selectedReferrerParams: null,
      selectedPaymentMethod: null,
      selectedOrderType: "all",
      selectedDeliveryPrice: "all",
      deliveryServiceStatus: null,
      selectedRestaurant: null,
      selectedRepresentative: null,
      selectedProvinces: [],
      selectedRegions: [],
      selectedUser: null,
      selectedCourier: null,
      selectedMenutepayCompany: null,
      selectedVoucher: null,
      uniqueUsers: false,
      startDate: null,
      endDate: null,
    },
    invoices: {
      startDate: null,
      endDate: null,
      selectedRestaurant: null,
    },
    txn: {
      startDate: null,
      endDate: null,
    },
    activities: {
      logName: null,
      startDate: null,
      endDate: null,
      causerType: null,
      selectedCauser: null,
      selectedSubject: null,
    },
    delivery_zones: {
      selectedZips: [],
    },
    menutepay: {
      selectedCompany: null,
    },
    task: {
      assigned: null,
      selectedAdmin: [],
      selectedRestaurant: null,
      status: [],
    },
    images: {
      type: "Category",
      tags: [],
    },
    vouchers: {
      selectedRestaurant: null,
      selectedUser: null,
      createdViaPoints: "all",
      isAppOnly: "all",
      isFirstTimeOnly: "all",
      onlyDelivery: "all",
      expiresAtOperator: null,
      expiresAtDate: null,
    },
    messages: {
      selectedSegment: null,
      isTest: null,
    },
    deliveryService: {
      couriers: {
        selectedHubs: [],
        selectedStatus: [],
        selectedContractModel: null,
        selectedEmploymentType: null,
        selectedVehicleMode: null,
      },
      hubs: {
        selectedDeliveryStatus: null,
      },
    },

    country: parseInt(localStorage.getItem("filters-country")) || null,
  },

  reports: {
    revenues: {
      orderChannels: [],
      paymentMethods: [],
      referers: [],
      restaurant: null,
    },
  },

  createPaymentShow: false,
  productPricesShow: false,
  restaurantCategoryShow: false,
  addCustomTimes: false,
  transferOrRevokeOrderShow: false,
  changeCourierForDeliveredOrderShow: false,
  updateCourierPriorityModalShow: false,
  bulkMenuUpdateShow: false,
  dnsManagementModalShow: false,
  domainRegistrationModalShow: false,

  // CRM
  crm: {
    hasUnreadMail: false,
    hasPendingTask: false,
  },

  // Default Country
  countryId: parseInt(localStorage.getItem("country")) || 1, // 1 = Belgium, 2 = Netherlands

  // Errors
  errors: [],
};

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarOpened ? false : "responsive";
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarClosed ? true : "responsive";
  },
  set(state, [variable, value]) {
    state[variable] = value;
  },
  toggle(state, variable) {
    state[variable] = !state[variable];
  },
  setCountry(state, country) {
    state.countryId = country;
    localStorage.setItem("country", country);
    state.filters.country = country;
    localStorage.setItem("filters-country", country);
  },
  setCountryFilter(state, country) {
    state.filters.country = country;
    if (country === null) {
      localStorage.removeItem("filters-country");
      return;
    }
    localStorage.setItem("filters-country", country);
  },

  setDeliveryServiceFilter(state, { key, value }) {
    const keys = key.split('.');
    const lastKey = keys.pop();
    let obj = state.filters.deliveryService;
    keys.forEach((key) => {
      obj = obj[key] = obj[key] || {};
    });
    obj[lastKey] = value;

    // localStorage.setItem(`delivery-service-${key}`, JSON.stringify(value));
  },

  // Errors
  setErrors(state, errors) {
    state.errors = errors;
  },
};

const getters = {
  errors: (state) => state.errors,
};

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions: {},
  modules: {
    auth,
    restaurants,
    settings,
    voip,
  },
});
